import { ref, reactive } from 'vue';
import { default as orderService } from './order-service';

window.br = window.br || {};

let cart = JSON.parse(document.getElementById('cart-data').value);
let fullCart = JSON.parse((document.getElementById('full-cart-data') || { value: '{"overview":{},"lines":[]}' }).value);
orderService.prepLines(fullCart.lines);

window.br.cart = reactive(cart);
window.br.fullCart = fullCart;

